import {
  Text,
  Box,
  Stack,
  Inline,
  Column,
  Columns,
  TooltipRenderer,
  IconInfo,
} from 'braid-design-system';

export const ProfileInsightsIndicator = ({
  text,
  count,
  tooltipText,
}: {
  text: string;
  count: number;
  tooltipText: string;
}) => (
  <Box
    background="neutralLight"
    borderRadius="standard"
    paddingY="large"
    paddingX="medium"
  >
    <Columns space="xsmall">
      <Column>
        <Stack space="medium">
          <Text size="standard">{text}</Text>

          <Inline space="none" alignY="bottom">
            <Text size="large" weight="strong">
              {count}
            </Text>
          </Inline>
        </Stack>
      </Column>
      <Column width="content">
        <TooltipRenderer
          id={`certsy-verified-indicator-tooltip-${text}`}
          tooltip={<Text>{tooltipText}</Text>}
          placement="top"
        >
          {({ triggerProps }) => (
            <Box aria-label="view description" {...triggerProps}>
              <Text align="right">
                <IconInfo tone="secondary" />
              </Text>
            </Box>
          )}
        </TooltipRenderer>
      </Column>
    </Columns>
  </Box>
);
